import IntroductionWithImage from "../../../components/IntroductionWithImage";
import MainImageCarousel from "../../../components/MainImageCarousel";
import StickyNavAndFooter from "../../layout/StickyNavAndFooter";
import { yogaMainBlog, yogaPageIntroduction, pathsToYogaCards } from "../../../data/data";
import { Box, Button, useDisclosure } from "@chakra-ui/react";
import meditation from '../../../resources/images/meditation.jpg'
import { primaryColor, secondaryColorTwo } from "../../../config";
import { CarouselCardDetails_t } from "../../../components/Carousels/CarouselCard";
import CardCarousalContainer from "../../../components/CardCarousalContainer";
import ModalPost from "../../../components/ModalPost";


export default function Yoga() {
    const { isOpen, onToggle } = useDisclosure()
    const yogaMainBlogForYogaPage: CarouselCardDetails_t = yogaMainBlog
    delete yogaMainBlogForYogaPage.previous;
    delete yogaMainBlogForYogaPage.next;
    function onClose() {
        onToggle()
    }

    return (
        <StickyNavAndFooter>
            <MainImageCarousel />
            <IntroductionWithImage img={meditation}>
                        {yogaPageIntroduction}
                        <br />
                        <Box textAlign={"right"}>
                            <Button bg={primaryColor} color={"white"} onClick={onToggle}
                                _hover={{
                                    backgroundColor: secondaryColorTwo,
                                }}>Read</Button>
                        </Box>
                    </IntroductionWithImage>
            {/* <Card>
                <CardBody>
                    <IntroductionWithImage img={meditation}>
                        {yogaPageIntroduction}
                        <br />
                        <Box textAlign={"right"}>
                            <Button bg={primaryColor} color={"white"} onClick={() => handleClick(yogaMainBlogForYogaPage.groupId + "_" + yogaMainBlogForYogaPage.id)}
                                _hover={{
                                    backgroundColor: secondaryColorTwo,
                                }}>Read</Button>
                        </Box>
                    </IntroductionWithImage>
                </CardBody>
            </Card> */}

            <br />
            <Box id={"paths-to-yoga"}>
                <CardCarousalContainer cards={pathsToYogaCards}
                    containerTitle={"Paths to Yoga"}
                    subTitle="Many paths till in Yoga!"
                    
                />
            </Box>

            {isOpen && <ModalPost card={yogaMainBlogForYogaPage}
                isOpen={isOpen}
                onClose={onClose}
                hideNavigation={true} />}
        </StickyNavAndFooter>
    )
}